import {
  FingerprintJSPro,
  FpjsProvider,
} from '@fingerprintjs/fingerprintjs-pro-react'
import { HeroUIProvider, ToastProvider } from '@heroui/react'
import { Theme } from '@radix-ui/themes'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import config from './config'
import './datadog'
import './index.css'
import '@radix-ui/themes/styles.css'

// Remove console logs in production
if (config.ENV !== 'development') {
  // eslint-disable-next-line no-console
  console.log = () => {}

  console.error = () => {}
  // eslint-disable-next-line no-console
  console.debug = () => {}
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <FpjsProvider
      loadOptions={{
        apiKey: 'eDitehht9iF7HkLvITU6',
        endpoint: [
          'https://security.app.bland.ai',
          FingerprintJSPro.defaultEndpoint,
        ],
        scriptUrlPattern: [
          'https://security.app.bland.ai/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
          FingerprintJSPro.defaultScriptUrlPattern,
        ],
      }}
    >
      <HelmetProvider>
        <HeroUIProvider>
          <ToastProvider placement="top-right" />
          <Theme appearance="light" scaling="90%">
            <App />
          </Theme>
        </HeroUIProvider>
      </HelmetProvider>
    </FpjsProvider>
  </React.StrictMode>,
)
